import { render, staticRenderFns } from "./PainPointScenario.vue?vue&type=template&id=27d5d0f3&scoped=true&"
import script from "./PainPointScenario.vue?vue&type=script&lang=js&"
export * from "./PainPointScenario.vue?vue&type=script&lang=js&"
import style0 from "./PainPointScenario.vue?vue&type=style&index=0&id=27d5d0f3&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d5d0f3",
  null
  
)

export default component.exports